import { KineticGeoJsonData } from '@kinetic-ui/shared';

export enum TunnelLayerState {
  TUNNELS = 'TUNNELS',
  TUNNEL_ZONES = 'TUNNEL_ZONES',
}

export type TunnelMapLayerData = KineticGeoJsonData;
